import { get, getProperties, set, setProperties } from '@ember/object';
import { sort } from '@ember/object/computed';
import Service, { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import LineItemValidations from '../validations/line-item';

export default Service.extend({
  store: service(),
  storeCache: service(),
  fundsService: service(),

  lastGiftForContact: null,
  transTypes: null,
  sortedTransTypes: sort('transTypes', function (a, b) {
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  }),

  _populateDataPromise: null,
  populateData() {
    let promise = this._populateDataPromise;
    if (promise) {
      return promise;
    }
    set(this, 'lastGiftForContact', {});
    promise = this.store
      .query('line-item', { filter: { last_gift: true } })
      .then((lastGifts) => {
        lastGifts.forEach((lineItem) => {
          set(
            this,
            `lastGiftForContact.${get(lineItem, 'contactId')}`,
            lineItem,
          );
        });
        return this.storeCache
          .findRecord(
            'transaction-filter-option',
            this.fundsService.selectedFund.id,
          )
          .then((record) => {
            let transTypes = get(record, 'transTypes');
            if (transTypes.length === 0) {
              transTypes.push('Gift');
            }
            set(this, 'transTypes', transTypes);
          });
      });
    set(this, '_populateDataPromise', promise);
    return promise;
  },

  reset() {
    setProperties(this, {
      _populateDataPromise: null,
      currentLineItems: [],
      lastGiftForContact: null,
      transTypes: null,
    });
  },

  // the LineItem's that are currently being edited
  // format: [{ model: nil, changeset: nil }]
  currentLineItems: [],

  addLine(initialValues = {}) {
    let { store, currentLineItems } = getProperties(
      this,
      'store',
      'currentLineItems',
    );
    let model = store.createRecord('line-item', initialValues);
    let changeset = new Changeset(
      model,
      lookupValidator(LineItemValidations),
      LineItemValidations,
    );
    let item = {
      model: model,
      changeset: changeset,
    };
    currentLineItems = [...currentLineItems, item];
    return item;
  },

  retrieveLine(id) {
    return this.store.findRecord('line-item', id).then((model) => {
      let changeset = new Changeset(
        model,
        lookupValidator(LineItemValidations),
        LineItemValidations,
      );
      return {
        model: model,
        changeset: changeset,
      };
    });
  },
});
